import React from 'react';

import { AuthProvider } from './Auth';
import { ResizeProvider } from './Resize';

const AppProvider: React.FC = ({ children }) => (
  <ResizeProvider>
    <AuthProvider>{children}</AuthProvider>
  </ResizeProvider>
);

export default AppProvider;
